<!-- 推广账户管理 - 华为 -->
<template>
<div>
	<div style="display: flex;align-items: center;">
		<div v-for="(item,index) in titleTab" :key="index"
		:class="{'title-tab-box-selected': item.select}" 
		@click="changeTab(item,index)"
		class="title-tab-box">{{item.label}}</div>
	</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;">
		<div class="screen-box">
			<div class="screen-label">推广账户名称</div>
			<a-input v-model="r_name" allowClear placeholder="请输入推广账户名称" style="width: 240px;"/>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">推广账户ID</div>
			<a-input v-model="r_account_id" allowClear placeholder="推广账户ID精准搜索" style="width: 240px;"/>
		</div>
		
		<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
		
		<a-button @click="addButton" class="screen-box" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增推广账户</a-button>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
		<div v-for="(item,index) in rableTitle" :key="index" >
			<div class="table-th-cell" 
			:style="{'width':item.width + 'px',}">
				{{item.title}}
			</div>
		</div>
	</div>
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<!-- 推广账户名称 -->
		<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
			{{item.name}}
		</div>
		<!-- 推广账户ID -->
		<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
			{{item.account_id}}
		</div>
		<!-- 回传秘钥 -->
		<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
			{{item.secret}}
		</div>
		<!-- 操作 -->
		<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}" style="display: flex;align-items: ;">
			
			<div @click="editTable(index,item)" style="color: #62a8ea;cursor: pointer;">编辑</div>
			<div @click="delTD(item)" style="color: red;cursor: pointer;margin-left:15px;">删除</div>
		</div>
	</div>
	
	<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="650px"
	  placement="right"
	  :closable="false"
	  :visible="drawer_visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			
			<div class="form-cell-box">
				<div class="class-title">推广账户名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_name" placeholder="请输入" style="width: 390px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">推广账户ID<span class="required-hint">*</span></div>
					
				<a-input v-model="x_account_id" placeholder="请输入" style="width: 390px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">账户秘钥<span class="required-hint">*</span></div>
					
				<a-input v-model="x_secret" placeholder="请输入" style="width: 390px;"  />
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { accountHWList, accountHWAdd, accountHWEdit, accountHWDel } from '@/request/api'
export default {
	name: 'accountHW_',
	components: {
		
	},
	data() {
		return {
			titleTab: [
				{label: "推广账户管理", select: true , value: 0 },
				// {label: "开发者账户管理", select: false , value: 1 },
			],
			content_type: 0, // 页面内容展现类型
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"推广账户名称", width:200, type:"name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"推广账户ID", width:180, type:"account_id", },
				{title:"回传秘钥", width:260, type:"secret", },
				{title:"操作", width:120, type:"cz", },
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1000,
			search_button_loading: false,
			table_total: 0,
			
			r_page: 1,
			r_limit: 100,
			r_name: null,
			r_account_id: null, // 推广账户ID
			
			// 设置参数侧边栏
			drawer_title: "", // 侧边栏标题
			drawer_visible: false,
			add_button_loading: false, // 侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_id: "",
			x_name: null, // 推广账户名称
			x_account_id: null, // 推广账户ID
			x_secret: null, // 账户秘钥
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.table_scroll_width = table_info.table_width
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		that.searchButton()
	},
	methods:{
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
			}
			
		},
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			accountHWList({
				page: that.r_page,
				limit: that.r_limit,
				name: that.r_name,
				account_id: that.r_account_id
			}).then(res=>{
				console.log("搜索",res);
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
			.catch(err=>{
				that.search_button_loading = false
				that.$message.error(`${err}`);
			})
		},
		// 新增
		addButton(){
			this.drawer_title = "新增"
			this.drawer_visible = true
		},
		// 编辑
		editTable(index,e){
			this.drawer_title = "编辑"
			console.log(e);
			
			this.x_id = e.id || ""
			this.x_name = e.name || null
			this.x_account_id = e.account_id || null
			this.x_secret = e.secret || null
			
			this.drawer_visible = true
		},
		// 删除
		delTD(e){
			let that = this
			console.log(e);
			this.$confirm({
				title: '确定删除?',
				content: `推广账户名称：${e.name}`,
				okText: '删除',
				okType: 'danger',
				cancelText: '取消',
				onOk() {
				  console.log('OK');
				  accountHWDel({
					  id: e.id
				  }).then(res=>{
					  console.log("删除",res);
					  that.$message.success('删除成功');
					  that.searchButton()
				  })
				},
				onCancel() {
				  console.log('Cancel');
				},
			});
		},
		// 侧边栏的确认按钮
		addRequest(){
			let that = this
			if(!that.x_name){
				that.add_form_hint = "请填写 推广账户名称"
			}
			else if(!that.x_account_id){
				that.add_form_hint = "请填写 推广账户ID"
			}
			else if(!that.x_secret){
				that.add_form_hint = "请填写 账户秘钥"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				if(that.drawer_title == "新增"){
					// 新增
					accountHWAdd({
						name: that.x_name,
						account_id: that.x_account_id,
						secret: that.x_secret,
					}).then(res=>{
						that.add_button_loading = false
						console.log('新增',res);
						that.onCloseDrawer()
						that.$message.success('新增成功');
						that.searchButton()
					})
				}
				else if(that.drawer_title == "编辑"){
					accountHWEdit({
						id: that.x_id,
						name: that.x_name,
						account_id: that.x_account_id,
						secret: that.x_secret,
					}).then(res=>{
						that.add_button_loading = false
						console.log('编辑',res);
						that.onCloseDrawer()
						that.$message.success('编辑成功');
						that.searchButton()
					})
				}
				
				
			}
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){
				return
			}
			this.add_form_hint = ""
			
			this.x_id = ""
			this.x_name = null
			this.x_account_id = null
			this.x_secret = null
			
			this.drawer_visible = false
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
	}
}
</script>

<style>
.class-title {
	width: 100px;
}
</style>